/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type NexonSearchRequest = {
    filterBy?: NexonSearchRequest.filterBy;
    term: string;
};

export namespace NexonSearchRequest {

    export enum filterBy {
        BLOCK = 'BLOCK',
        TRANSACTION = 'TRANSACTION',
        ADDRESS = 'ADDRESS',
        TOKEN = 'TOKEN',
        NFT = 'NFT',
        ALL = 'ALL',
    }


}

